import axios from '@/components/api/axios';

async function getCalendarTypeList() {
  const res = await axios.axiosGet('/api/calendar/getTypeList', null);
  return res;
}

async function getCalendarMonthList(calendarTypeId, targetYm) {
  let data = {
    calendarTypeId: calendarTypeId,
    targetYm: targetYm
  }
  const res = await axios.axiosGet('/api/calendar/getCalendarMonthList', data);
  return res;
}

async function getCalendarDayList(calendarTypeId, targetYmd) {
  let data = {
    calendarTypeId: calendarTypeId,
    targetYmd: targetYmd
  }
  const res = await axios.axiosGet('/api/calendar/getCalendarDayList', data);
  return res;
}

async function getCalendarDetail(calendarId) {
  let data = {
    calendarId: calendarId
  }
  const res = await axios.axiosGet('/api/calendar/getCalendarDetail', data);
  return res;
}

export default {
  getCalendarTypeList,
  getCalendarMonthList,
  getCalendarDayList,
  getCalendarDetail
}



// WEBPACK FOOTER //
// ./src/components/api/calendar.js